import React from "react";

export default function Footer() {
  return (
    <footer className="mt-20 bg-black text-white" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 py-14 grid md:grid-cols-4 gap-8">
        <div>
          <div className="font-display font-black uppercase text-xl tracking-tight">
            HW/Engineering<span style={{ color: "#FFB800" }}>.</span>
          </div>
          <p className="text-sm text-white/70 mt-3 leading-relaxed">
            Asynchronous hardware engineering reports for teams that move fast.
          </p>
        </div>
        <div>
          <div className="ribbon text-white/60 mb-3">Services</div>
          <ul className="space-y-2 text-sm">
            <li><a href="/#services">Diagnostic Reports</a></li>
            <li><a href="/#services">SOP Documentation</a></li>
            <li><a href="/#services">Cost Optimization</a></li>
          </ul>
        </div>
        <div>
          <div className="ribbon text-white/60 mb-3">Company</div>
          <ul className="space-y-2 text-sm">
            <li><a href="/#how">How it works</a></li>
            <li><a href="/#faq">FAQ</a></li>
            <li><a href="/login">Customer login</a></li>
          </ul>
        </div>
        <div>
          <div className="ribbon text-white/60 mb-3">Disclaimer</div>
          <p className="text-xs text-white/60 leading-relaxed">
            All recommendations are advisory. Clients must validate changes in their environment.
            No liability for data loss, downtime or damage. Reports are informational, not guarantees.
          </p>
        </div>
      </div>
      <div className="border-t border-white/10 px-6 py-5 text-xs text-white/50 ribbon flex flex-wrap gap-3 justify-between max-w-7xl mx-auto">
        <span>© 2026 HW/Engineering Services</span>
        <span>BUILT FOR ENGINEERS · ASYNC · NO CALLS</span>
      </div>
    </footer>
  );
}
